export class Address {
    public AddressType!: string;
    public Address1!: string;
    public Address2!: string;
    public Province!: string;
    public PostalCode!: string;
    public Country!: string;
    public IssueFulfillment!: boolean;
    public FulfillmentLanguage!: string;

    constructor(){       
        this.AddressType="HOME";
        this.Country="CA";
    }
}